<template>
  <div id="page" ref="homePage" class="page">
    <process :process-val="2" />
    <!-- 已预约成功  -->
    <div v-if="recordData.is_interview == 4" class="main">
      <div class="top-bg" />
      <div class="content-box">
        <div class="tips" />
        <div class="result-text succeed">你已预约成功</div>
        <div class="result-title">面试时间</div>
        <div class="result-hint"> {{ recordData.meetdate | dataFilters }} {{ recordData.interview_time }}  </div>
        <div class="result-title">面试官</div>
        <div class="result-hint">请截图扫码添加面试官</div>
        <div class="result-remark1">*好友验证请备注：姓名+城市+面试时间</div>
        <div class="result-remark">*如需更换面试时间，请直接与面试官联系</div>
        <div class="cover">
          <img :src="interviewerData.img_url" class="cover-path">
        </div>
      </div>
    </div>
    <!-- 面试结束 -->
    <div v-if="recordData.is_interview == 2" class="main">
      <div class="top-bg" />
      <div class="content-box">
        <div class="tips-condition" />
        <div class="result-text">面试已结束</div>
        <div class="result-line" />
        <div class="result-hint">面试结果将在12小时内更新，<br>请随时进入本界面查看，并留意邮件</div>
        <div class="result-line" />
        <div class="result-hint">你会在YES GO经历</div>
        <div class="result-btn" @click="goToMore">查看YES GO介绍</div>
        <div class="cover">
          <img :src="interviewerData.img_url" class="cover-path">
        </div>
      </div>
    </div>
    <!-- 已放弃面试 -->
    <div v-if="recordData.is_interview == 3" class="main">
      <div class="top-bg" />
      <div class="content-box">
        <div class="tips-condition" />
        <div class="result-text gary">你已放弃面试</div>
        <div class="result-line" />
        <div class="result-hint">感谢你报名YES GO，<br> 期待再次与你相遇。</div>
        <div class="result-line" />
        <div class="result-hint">进一步了解YES GO</div>
        <div class="result-btn" @click="goToMore">查看YES GO介绍</div>
        <div class="cover">
          <img :src="interviewerData.img_url" class="cover-path">
        </div>
      </div>
    </div>
    <!--  你未参加面试  -->
    <div v-if="recordData.is_interview == 1" class="main">
      <div class="top-bg" />
      <div class="content-box">
        <div class="tips-condition" />
        <div class="result-text gary">你未参加面试</div>
        <div class="result-line" />
        <div class="result-hint">如需重新预约或更改状态，<br>请联系面试官。</div>
        <div class="result-line" />
        <div class="result-hint">重新了解YES GO</div>
        <div class="result-btn" @click="goToMore">查看YES GO介绍</div>
        <div class="cover">
          <img :src="interviewerData.img_url" class="cover-path">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Button, Toast, Dialog } from 'vant'
import { interviewRecord } from '@/api/interview'
import { getLogin } from '@/utils/auth' // 获取auth参数
import process from '../components/process'
// import { getUserApplyRecord } from '@/api/apply'

export default {
  name: 'Interviewer',
  components: {
    [Button.name]: Button,
    process
  },
  filters: {
    dataFilters(val) {
      if (val) {
        return val.substr(0, 10)
      }
    }
  },
  data: function() {
    return {
      recordData: {}, // 面试信息
      interviewerData: {} // 面试官信息
    }
  },
  created() {
    Toast.loading({
      duration: 0,
      forbidClick: true,
      loadingType: 'spinner',
      message: '加载中...'
    })
    // this.checkUserEvaluation()
    if (sessionStorage.getItem('userPhone')) {
      this.phone = sessionStorage.getItem('userPhone')
      this.getInterviewRecord()
    } else {
      Dialog.alert({
        title: '温馨提示',
        message: '系统未检测到您的手机号，请前往绑定'
      }).then(() => {
        this.$router.replace('/') // 返回首页
      })
    }
  },
  methods: {
    // 检查用户是否提交测评 484: 测评表单
    // checkUserEvaluation() {
    //   getUserApplyRecord({
    //     activity_id: 484,
    //     open_id: getLogin()
    //   }).then(res => {
    //     if (res.data.code === 200 && res.data.data.enroll_code) {
    //       console.log('484活动', res.data.data)
    //       this.getInterviewRecord()
    //     } else {
    //       Toast.clear()
    //       this.goto('/evaluation')
    //     }
    //   })
    // },
    getInterviewRecord() {
      var that = this
      interviewRecord({
        open_id: getLogin(),
        user_phone: this.phone
      }).then(res => {
        console.log('预约', res.data.data)
        if (res.data.code === 200 && res.data.data.interviewer) {
          this.recordData = res.data.data.record
          this.interviewerData = res.data.data.interviewer
          if (res.data.data.record.is_interview === 2 && res.data.data.record.is_loss !== 2) { // if：已参加面试 并且不是流失状态
            var show = res.data.data.record.is_show
            var success = res.data.data.record.success_type
            var pay = res.data.data.pay_info.pay_way
            if (show === 2 && pay === 0) { // if: 已通过面试 and 未支付状态
              switch (success) {
                case 1: // case：面试结果为“已通过”，邮件发送状态为“已发送”, 邮件发送时间在24小时内
                  that.goto('/result?showType=2')
                  break
                case 2: // case：面试结果为“已通过” ，邮件发送状态为“已发送”，邮件发放后24小时后，48小时内
                  that.goto('/entrance?showType=1')
                  break
                case 3: // case：超过48小时
                  that.goto('/entrance?showType=2')
                  break
              }
            } else if (show === 3 && pay === 0) { // if: 没通过面试 and 未支付状态
              that.goto('/result?showType=3')
            } else if (pay === 2) { // if: 分期中
              that.goto('/result?showType=2')
            } else if (pay === 1 || pay === 3) { // if: 已支付
              that.goto('/entrance?showType=3')
            }
          } else if (res.data.data.record.is_loss === 2) { // if: 已流失状态
            that.goto('/entrance?showType=2')
          } else if (res.data.data.record.is_interview === 0 && !res.data.data.record.interview_time) {
            that.$router.replace('/') // 返回首页
          }
          Toast.clear()
        } else {
          Toast.clear()
          Dialog.alert({
            title: '温馨提示',
            message: '未检测到您到预约资料，请重试'
          }).then(() => {
            that.$router.replace('/') // 返回首页
          })
        }
      })
    },
    goto(path) {
      this.$router.replace(path)
    },
    goToMore() {
      window.location.href = 'https://link.yes-go.cn/4u'
    }
  }
}
</script>

<style lang="less" scoped>
  .page{
    width: 375px;
    background: url("../images/result_bg1.jpg") repeat-y center;
    background-size: 100%;
    padding: 20px 0 0 0;
  }
  .main{
    position: relative;
    z-index: 1;
    width: 310px;
    margin: 0 auto;
    top: -20px;
    .tips{
      position: absolute;
      top: -20px;
      left: 30px;
      width: 140px;
      height: 35px;
      background: url("../images/make_tips.png") no-repeat;
      background-size: contain;
    }
    .tips-condition{
      position: absolute;
      top: -20px;
      left: 30px;
      width: 140px;
      height: 35px;
      background: url("../images/condition_tips.png") no-repeat;
      background-size: contain;
    }
    .top-bg{
      border-radius: 0 15px 0 0;
      background: #FFF;
      width: 50%;
      height: 30px;
      margin-left: 50%;
      padding-bottom: 10px;
      position: relative;
      top: 20px;
      z-index: 1;
      &:before{
        content: '';
        font-size:0;
        border-style:solid;
        overflow:hidden;
        position:absolute;
        border-width:46px;
        border-color: transparent #FFF transparent transparent;
        left:-92px;
        top: 0;
        z-index: 1;
      }
    }
    .content-box{
      position: relative;
      border-radius: 10px 10px 0 10px;
      background: #fff;
      padding: 20px 20px 10px 20px;
      z-index: 2;
    }
    .result-text{
      text-align: center;
      border-bottom: 1px solid #444;
      color: #ee5030;
      font-weight: bold;
      font-size: 26px;
      line-height: 55px;
      margin: 0 12px;
      &.succeed{
        padding-left: 30px;
        background: url('../images/icon_smile.png') no-repeat 20px;
        background-size: 30px;
      }
      &.gary{
        color: #5d5d5d;
      }
    }
    .result-title{
      background: rgba(161, 161, 161, 0.1);
      color: #ee5030;
      font-weight: bold;
      font-size: 18px;
      height: 34px;
      line-height: 34px;
      margin: 12px 12px 8px 12px;
      text-align: center;
    }
    .result-hint{
      color: #000;
      font-size:16px;
      line-height: 30px;
      text-align: center;
    }
    .result-remark{
      text-align: center;
      line-height: 30px;
      color: #999;
      font-size: 13px;
    }
    .result-remark1{
      text-align: center;
      line-height: 30px;
      color: #ee5030;
      font-size: 14px;
      font-weight: bold;
    }
    .result-line{
      width: 20px;
      height: 3px;
      background: #ee5030;
      margin: 12px auto;
    }
    .result-btn{
      border: 1px solid #ee5030;
      text-align: center;
      height: 38px;
      line-height: 38px;
      border-radius: 4px;
      font-weight: bold;
      color: #ee5030;
      font-size: 18px;
      margin: 20px 12px;
    }
  }
  .cover{
    margin-top: 12px;
    width: 100%;
    background: #fff;
    .cover-path{
      width: 100%;
    }
  }
</style>
